import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IInquiryCndsState, IPjt0104MState, IPjtItemState, IUserItemState, IProjectCdItemState } from '../../models/pjt/pjt0104m_model';
  
const initialState: IPjt0104MState = {
    userList : [],      // 사용자목록(조회조건)
    projectCdList : [], // 프로젝트코드목록(조회조건)
    projectList: [],    // 프로젝트목록

    inquiryCnds: {},    // 조회조건

    pageSize : 20,          // 페이징사이즈
    current : 0,            // 현재페이지
}

export const pjt0104m_Slice = createSlice({
    name: "pjt0104m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState,
                                  userList : state.userList});
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setProjectCdList: (state, action:PayloadAction<IProjectCdItemState[]>) => {
            state.projectCdList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setProjectList: (state, action:PayloadAction<IPjtItemState[]>) => {
            state.projectList = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default pjt0104m_Slice.reducer;
export const Pjt0104mAction  = pjt0104m_Slice.actions;
export const Pjt0104mReducer = pjt0104m_Slice.reducer;